import axios from "axios";
import {
  SpaceUserPermissionsInterface,
  SpaceUserEnableInterface,
} from "../../resources/interfaces/spaceUserInterfaces";
export class SuperSpaceUserService {
  async getSuperSpaceUsers(
    superSpace: number,
    page: number,
    itemsPerPage: number,
    search: string,
    permision: string
  ): Promise<any> {
    return axios.get(
      `api/super_space_users?superSpace=${superSpace}&page=${page}&itemsPerPage=${itemsPerPage}${search}${permision}&order[user.name]=ASC&order[user.lastName]=ASC`
    );
  }
  async updateSuperSpaceUserPermissions(
    superSpaceUserId: number,
    data: SpaceUserPermissionsInterface
  ): Promise<any> {
    return await axios.put(
      `api/super_space_users/${superSpaceUserId}/give_permissions`,
      data
    );
  }
  async updateCollectionSuperSpaceUserPermissions(data): Promise<any> {
    return await axios.put(`api/super_space_users/give_permissions`, data);
  }
  async enableSuperSpaceUser(
    superSpaceUserId: number,
    data: SpaceUserEnableInterface
  ): Promise<any> {
    return await axios.put(
      `api/super_space_users/${superSpaceUserId}/enable`,
      data
    );
  }
  async deleteSuperSpaceUser(superSpaceUserId: number): Promise<any> {
    return await axios.delete(`/api/super_space_users/${superSpaceUserId}`);
  }
  async updateSuperSpaceUserHostPermissions(
    superSpaceUserId: number,
    data: SpaceUserPermissionsInterface
  ): Promise<any> {
    return await axios.put(
      `api/super_space_users/${superSpaceUserId}/give_webinar_host_permission`,
      data
    );
  }
}
